const canciones = [
    {
        title: "TODOS LOS DIAS (CANCIÓN DE LA RODRIGO)",
        lyrics: `Todos los días
pensando en esta falla,
cantando tonterías
para sentirme bien.
Las alegrías
que yo aquí he vivido,
irán siempre conmigo
dentro del corazón.
Recordaré todos esos
momentos
que siempre llevo dentro
a esta comisión.
Con estas frases
estas bonitas frases.
Te pido que tu cantes
conmigo esta canción.
Por eso yo...te cantaré.
Siempre en alta voz
soy de la falla Rodrigo.
De rodrigo el corazón.
Yoooo...te cantaré.
Siempre en alta voz
soy de la falla Rodrigo.
De Rodrigo el corazón.
Todos los años
siempre todos los años
cuando llega marzo
me pongo a tiritar.
Tiritita.
Serán los nervios
porque llegaron fallas
y en un casal del Puerto
se viven especial.
Y es que en mi cuerpo
solo hay sangre fallera
que corre por mis venas
no lo puedo evitar.
Somos falleros
de la falla Rodrigo,
por más que quieran muchos
no nos podrán callar.
Por eso yo...te cantaré.
Siempre en alta voz
soy de la falla Rodrigo.
De Rodrigo el corazón.
Yoooo...te cantaré.
Siempre en alta voz
soy de la falla Rodrigo.
De rodrigo el corazón.`,
    },
    {
        title: "SOM FALLERS",
        lyrics: `Sooooooooooom faaaallers de la Rodriiiiigo
Y ningú ens callará
anirem per tots els llocs,
orgullosos de qui som,
de la Rodrigo la millor falla del Mon.
Lo, lo, lo, lo, Lo, lo, lo,
Lo, lo, lo, lo, Lo, lo, lo,
anirem per tots els llocs,
orgullosos de qui som,
de la Rodrigo la millor falla del Mon.`,
    }, {
        title: "LA MANTA AL COLL",
        lyrics: `Una volta quan tornava
El tio pep de l’horta
Es va trobar de casa
Oberta la porta
Pujant per l’escaleta
Es trobà un senyoret
Que amb la bragueta oberta
li ensenyava el cacahuet.
ESTRIBILLO:
La manta al coll i el cabaset
Mon arirem al postiguet
La manta al coll i el cabaset
Mon anirem mon anirem al postiguet
Arreando chim pam pum, arreando chim pam pum
Les xiquetes de xixona
S’han comprat una romana
Pa pesar-se les mamelles
Tres voltes a la setmana
Si vols que te les pesen
Pega volta cap amunt
I voras que polseguera
Que te ix per baix del cul.
ESTRIBILLO (el mismo que antes)
Per 2 quincets un puro
Per 3 una pipa
Per 4 un guitarra
Per 5 una xica
El puro pa fumar
La pipa pa lluir
La guitarra pa tocar
I la xica pa dormir
ESTRIBILLO =`,
    }, {
        title: "ES TARONJA EL MEU COLOR",
        lyrics: `És taronja el meu color
TODOS REPITEN: És taronja el meu color
El taronja dins del cor
TODOS REPITEN: El taronja dins del cor
La Rodrigo ballarà
TODOS REPITEN: La Rodrigo ballarà
La Rodrigo cantarà.
TODOS REPITEN: La Rodrigo cantarà.
Oe oe, oe oe, oe oe oeoeoee
Oe oe, oe oe, oe oe oeoeoee`,
    }, {
        title: "SOMOS FALLEROS DE LA RODRIGO",
        lyrics: `Somos falleros

de la Rodrigo
Somos festeros
Y sobre todo amigos.
Y Siempre en marzo
Nos reunimos
Cantando juntos
Ale mucho Rodrigo.
Ale ale, ale ale, ale ale mucho Rodrigo ale ale
Ale ale, ale ale, ale ale mucho Rodrigo ale ale`,
    }, {
        title: "JA ESTEM ACÍ",
        lyrics: `Ja estem ací
ja hem arrivat
som la Rodrigo
de enguany.
Per a cantar
per a ballar
i emborratxar-nos
aquest any.
Ja estem ací
ja hem arrivat
som la Rodrigo
de enguany.
Vinga, vinga vingau
que ja la festa va començaaaaar,
vinga, vinga vingau
perquè la festa comença ja.`,
    }, {
        title: "RODRIGO MECAGÜENLA",
        lyrics: `Roooooooooooooodrigo, mecagüenla
la mejor falla, mecagüenla
la que más beben
y menos mean
Rodrigo, mecagüenla
la mejor falla, mecagüenla
la que más beben
y menos mean
Lalala,lalala,lalalalala….
Lalala,lalala,lalalalala….`,
    }, {
        title: "ALE MUCHO RODRIGO",
        lyrics: `Ale mucho rodrigo ale ,ale
Ale mucho rodrigo ale ,ale
Ale, ale,ale… ale ale ale,
Ale mucho rodrigo ale ,ale.
Ale mucho rodrigo ale ,ale
Ale mucho rodrigo ale ,ale
Ale, ale,ale… ale ale ale,
Ale mucho rodrigo ale ,ale.`,
    }, {
        title: "SI TU TE QUIERES DIVERTIR (Versión de Rosa Marín) Y A MI ME LLAMAN EL TABLÓN",
        lyrics: `A mí me llaman el tablón
porque me gusta el Morapio
que yo prefiero beber vino
a que me llamen Serapio… SERAPIO KABRON
Que yo no bebo por beber
que bebo para olvidar,
porque bebiendo me olvido
porque bebiendo me olvido….
¿De qué? de qué? ¿de qué?
de tener que trabajar.
Si tú te quieres divertir
ven a acercarte a mi falla
te quedaras alucinao ALUCINAO ALUCINAO
porque esto es una pasada.
Dame la mano y ven conmigo
ven acercarte a Rodrigo
y veras qué fácil es y veras que fácil es
¿El qué? ¿El qué? ¿El qué?
Hacer mogollón de amigos.`,
    }, {
        title: "ALCOHOL, ALCOHOL.",
        lyrics: `Alcohol, alcohol,
alcohol, alcohol, alcohol,
hemos venido a emborracharnos,
el resultado nos da igual.
Alcohol, alcohol,
alcohol, alcohol, alcohol,
hemos venido a emborracharnos,
el resultado nos da igual.
IGUAL PERO MÁS RÁPIDO.
Alcohol, alcohol,
alcohol, alcohol, alcohol,
hemos venido a emborracharnos,
y además hemos ganao
Alcohol, alcohol,
alcohol, alcohol, alcohol,
hemos venido a emborracharnos,
y además hemos ganao`,
    }, {
        title: "LOS DEDOS",
        lyrics: `(ellos)

Los dedos de las manos,
los dedos de los pies,
la polla y los cojones
me suman veintitrés

(ellas)

Los dedos de las manos
Los dedos de los pies
el coño y las dos tetas
me suman veintitrés
oeoeoeoeoeeoooeoee`,
    }, {
        title: "SI NOS PREGUNTAN DE DONDE SOMOS",
        lyrics: `Si nos preguntan de dónde somos,
contestaremos en alta voz…. EN ALTA VOZ, EN ALTA VOZ
que somos de una falla del puerto
y que se llama la Rodrigo, LA RODRIGO.
Si nos preguntan que, si es bonita,
contestaremos que mucho no…QUE MUCHO NO, QUE MUCHO
NO,
Pero que tiene unos falleros
que donde van arman follón, ARMAN FOLLON`,
    }, {
        title: "SOMOS LA RODRIGO",
        lyrics: `Somos la Rodriiiiiiiigo,
y estamos requetebién,
con marcha dentro del cuerpo
y alcohol en la sangre también.
Somos la Rodriiiiiiiigo,
y estamos requetebién,
con marcha dentro del cuerpo
y alcohol en la sangre también.`,
    }, {
        title: "QUE VIENE LA RODRIGO",
        lyrics: `Que viene la Rodriiiiiiiiiiiiigo, pachin
que vienen los Rodriguiiiiitos, pachin
y vienen muy cocidiiiiiiiiiiitos, pachin, pachin, pachin
mucho cuidado con lo que bebéis
pachin pachin pachin
O como nosotros os pondréis.`,
    },
];

export default canciones;
